import { MutationTree } from 'vuex'
import { AuditLogEntryModel } from './models'
import { AuditLogMutation, AuditLogState } from './types'

export const mutations: MutationTree<AuditLogState> = {
  [AuditLogMutation.setAuditLogEntries](state, payload: AuditLogEntryModel[]) {
    state.auditLogEntries = payload
  },
}
